import {
  Grid,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Slide,
  Button,
} from "@material-ui/core";
// Component
import BusinessReport from "./businessReport";
import BusinessReportTemplate from "./businessReportTemplate";
import OneEmployeeReport from "./oneEmployeeReport";
import OneEmployeeReportTemplate from "./oneEmployeeReportTemplate";
import EmployeeReportTemplate from "./employeeReportTemplate";
import EmployeeReport from "./employeeReport";
import "../../../css/reportPage.css";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
// Lib
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import classNames from "classnames";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { styles } from "./styles";
import { log } from "util";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class ReviewReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  createPdf = () => {
    const {
      datetimeBusiness,
      datetimeOneEmployee,
      datetimeEmployee,
    } = this.props;
    let { t, setting, service, typeReport } = this.props;
    if (typeReport == "business") {
      let data = {
        listBookings: this.props.listBookings,
        totalBooking: this.props.totalBooking,
        listOrders: this.props.listOrders,
        totalOrder: this.props.totalOrder,
        from: new Date(moment(datetimeBusiness, "YYYYMM")).getTime(),
        to: new Date(
          moment(datetimeBusiness, "YYYYMM").add(
            moment(datetimeBusiness, "YYYYMM").daysInMonth() - 1,
            "days"
          )
        ).getTime(),
        setting: setting,
        service: service,
        serviceCost: this.props.serviceCost,
        t: t,
      };
      let businessReport = BusinessReportTemplate(data);
      pdfMake.createPdf(businessReport).open({}, window);
    } else if (typeReport == "employee") {
      let data = {
        listOrders: this.props.listOrders,
        totalOrder: this.props.totalOrder,
        from: new Date(moment(datetimeEmployee, "YYYYMM")).getTime(),
        to: new Date(
          moment(datetimeEmployee, "YYYYMM").add(
            moment(datetimeEmployee, "YYYYMM").daysInMonth() - 1,
            "days"
          )
        ).getTime(),
        datetime: moment(datetimeEmployee),
        listEmployee: this.props.listEmployee,
        t: t,
      };
      let emplopyeeReport = EmployeeReportTemplate(data);
      pdfMake.createPdf(emplopyeeReport).open({}, window);
    } else if (typeReport == "oneEmployee") {
      let data = {
        listOrders: this.props.listOrders,
        totalOrder: this.props.totalOrder,
        from: new Date(moment(datetimeOneEmployee, "YYYYMM")).getTime(),
        to: new Date(
          moment(datetimeOneEmployee, "YYYYMM").add(
            moment(datetimeOneEmployee, "YYYYMM").daysInMonth() - 1,
            "days"
          )
        ).getTime(),
        setting: setting,
        oneEmployee: this.props.oneEmployee,
        bonusEmployee: this.props.bonusEmployee,
        t: t,
      };
      let oneEmployeeReport = OneEmployeeReportTemplate(data);
      pdfMake.createPdf(oneEmployeeReport).open({}, window);
    }
  };
  render() {
    const {
      classes,
      t,
      datetimeBusiness,
      datetimeEmployee,
      datetimeOneEmployee,
      typeReport,
    } = this.props;

    return (
      <React.Fragment>
        <Dialog
          fullScreen
          open={this.props.openReview}
          onClose={this.props.handleDialogEditClose}
          TransitionComponent={Transition}
          keepMounted
          classes={{
            paperWidthSm: classes.paperWidthSm,
          }}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <Loading onRef={(load) => (this.loading = load)} />
          <Snackbar
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
          <DialogTitle
            id="scroll-dialog-title"
            disableTypography
            className={classes.p0}
          >
            <Grid
              container
              spacing={0}
              justify="center"
              alignItems="center"
              className={classes.headDialog}
            >
              <Grid item xs={1} sm={6} md={6}>
                <Typography className={classes.titleDialog}>
                  {t("report_review_report")}
                </Typography>
              </Grid>
              <Grid
                item
                xs={11}
                sm={6}
                md={6}
                className={classNames(classes.wrapButton)}
              >
                <Button
                  variant="contained"
                  component="span"
                  color="primary"
                  className={classNames(classes.button)}
                  onClick={this.createPdf}
                >
                  {t("report_print")}
                </Button>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            {typeReport == "oneEmployee" && (
              <OneEmployeeReport datetime={datetimeOneEmployee} />
            )}
            {typeReport == "employee" && (
              <EmployeeReport datetime={datetimeEmployee} />
            )}
            {typeReport == "business" && (
              <BusinessReport datetime={datetimeBusiness} />
            )}
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
const mapState = (state) => ({
  listBookings: state.report.listBookings,
  totalBooking: state.report.totalBooking,
  listOrders: state.report.listOrders,
  totalOrder: state.report.totalOrder,
  setting: state.setting.setting,
  service: state.service.service,
  serviceCost: state.serviceCost.serviceCost,
  listEmployee: state.employees.employee,
  oneEmployee: state.employees.oneEmployee,
  bonusEmployee: state.employees.bonusEmployee,
});

const mapDispatch = (dispatch) => ({
  getListBookings: dispatch.report.getBookingReportSpa,
  getListOrders: dispatch.report.getListOrdersReportSpa,
  getListEmployeeSalary: dispatch.employees.getListEmployeeSalary,
  getServiceCost: dispatch.serviceCost.getServiceCost,
  getListEmployeeService: dispatch.employees.getListEmployeeService,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ReviewReport)
  )
);
